import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { QuestionStep } from '../../models/step/question-step.model';
import { QuestionnaireType } from '../../shared/enums/questionnaire-type.enum';
import { ThankYouType } from '../../shared/enums/thank-you-type.enum';
import { addIcons } from 'ionicons';
import { arrowForward } from 'ionicons/icons';
import { IonButton, IonIcon } from '@ionic/angular/standalone';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [IonButton, IonIcon],
  host: {
    '(window:keydown.shift.enter)': 'onNextHotkey($event)',
  },
})
export class FooterComponent {
  /**
   * Enum template injection
   */
  public readonly ThankYouType: typeof ThankYouType = ThankYouType;

  /**
   * Event which triggers going to the previous step.
   */
  public readonly prev: OutputEmitterRef<MouseEvent | KeyboardEvent> = output<
    MouseEvent | KeyboardEvent
  >();

  /**
   * Event which triggers going to the next step.
   */
  public readonly next: OutputEmitterRef<MouseEvent | KeyboardEvent> = output<
    MouseEvent | KeyboardEvent
  >();

  /**
   * The question that is currently being displayed in the template.
   */
  public readonly step: InputSignal<QuestionStep> =
    input.required<QuestionStep>();

  /**
   * Determines if we need to disabled the previous button.
   */
  public readonly disablePrevButton: InputSignal<boolean> =
    input<boolean>(false);

  /**
   * Determines if we need to disabled the previous button.
   */
  public readonly disableNextButton: InputSignal<boolean> =
    input<boolean>(false);

  /**
   * Expose the QuestionnaireType enum to the template.
   */
  public questionnaireType: typeof QuestionnaireType = QuestionnaireType;

  /**
   * Post the answer and navigate to the next question.
   */
  public onNextHotkey(event: Event): void {
    this.next.emit(event as KeyboardEvent);
  }

  public onNextClicked(event: MouseEvent): void {
    this.next.emit(event);
  }

  public onPrevClicked(event: MouseEvent): void {
    this.prev.emit(event);
  }

  constructor() {
    addIcons({ arrowForward });
  }
}
